import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function CareerDetails2() {
  return (
    <>
      <Header />

      <section className="container" style={{ paddingTop: "120px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginBottom: "40px",
          }}
        >
          <div
            style={{
              width: "300px",
              height: "1px",
              backgroundColor: "#dcdcdc",
            }}
          ></div>

<p style={{ margin: 0, fontSize: "16px", color: "#888" }}>
  <Link to="/" style={{ color: "#111", textDecoration: "none", fontWeight: 600 }}>Home</Link>
  {" / "}
  <Link to="/careers" style={{ color: "#111", textDecoration: "none", fontWeight: 600 }}>Careers</Link>
  {" / "}
  Full Stack Developer Intern
</p>
        </div>

        <h1
          style={{
            textAlign: "center",
            fontSize: "64px",
            lineHeight: "1.1",
            marginBottom: "80px",
          }}
        >
          <span style={{ fontWeight: "600" }}>
            Full Stack
          </span>
           <br />
          <span style={{ fontWeight: "300" }}>
            Developer Intern
          </span>
        </h1>

        <div style={{ maxWidth: "720px", margin: "0 auto" }}>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Position:</strong> Full Stack Developer Intern
          </p>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Job ID:</strong> BNWJB20260136
          </p>

          <p style={{ marginBottom: "15px", fontSize: "16px" }}>
            <strong>Employment Type:</strong> Internship (Remote)
          </p>

          <p style={{ marginBottom: "40px", fontSize: "16px" }}>
            <strong>Experience:</strong> Freshers
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "25px",
            }}
          >
            BlackWhite Creative Services is looking for a passionate and driven
            Full Stack Developer Intern to join our growing team. This is a
            6-month internship opportunity designed for individuals who are eager
            to build real-world applications, work on live projects, and gain
            hands-on experience across both front-end and back-end development.
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "40px",
            }}
          >
            As a Full Stack Developer Intern, you will be involved in designing,
            developing, and maintaining web applications that align with client
            requirements and business goals. You will collaborate closely with
            designers, developers, and project managers to create seamless digital
            experiences while improving your skills in UI implementation,
            server-side logic, database management, API integration, and
            performance optimization.
          </p>

          <h4 style={{ marginBottom: "25px" }}>
            Key Responsibilities:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Develop responsive and user-friendly web interfaces</li>
            <li>Build and maintain scalable backend services and APIs</li>
            <li>
              Collaborate with UI/UX designers to translate designs into
              functional applications
            </li>
            <li>Write clean, efficient, and well-documented code</li>
            <li>
              Debug, test, and optimize applications for performance and
              usability
            </li>
            <li>
              Stay updated with the latest technologies and development
              practices
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Qualifications & Requirements:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>
              Basic understanding of front-end technologies such as HTML, CSS,
              and JavaScript
            </li>
            <li>
              Familiarity with frameworks like React, Angular, or Vue.js is a
              plus
            </li>
            <li>
              Knowledge of backend technologies such as Node.js, Python, PHP,
              or Java
            </li>
            <li>
              Understanding of databases like MySQL, MongoDB, or PostgreSQL
            </li>
            <li>
              Basic knowledge of version control systems like Git
            </li>
            <li>
              Strong problem-solving and logical thinking skills
            </li>
            <li>
              Ability to learn quickly and adapt to new technologies
            </li>
            <li>
              Good communication skills and ability to work in a team
              environment
            </li>
            <li>
              Pursuing or recently completed a degree in Computer Science,
              Information Technology, or a related field
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            What You'll Gain:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>
              Hands-on experience working on real client and internal projects
            </li>
            <li>
              Exposure to end-to-end product development
            </li>
            <li>
              Mentorship from experienced professionals
            </li>
            <li>
              A collaborative and creative work environment
            </li>
            <li>
              Experience Letter and Letter of Recommendation based on
              performance
            </li>
          </ul>

          <h4 style={{ marginBottom: "25px" }}>
            Internship Details:
          </h4>

          <ul
            style={{
              color: "#777",
              fontSize: "16px",
              lineHeight: "2",
              marginBottom: "40px",
            }}
          >
            <li>Work Mode: Remote</li>
            <li>Duration: 6 Months</li>
            <li>
              Working Hours: Flexible schedule with expected commitment of
              20–25 hours per week
            </li>
            <li>
              Immediate and follow-up opportunities during working days
              preferred
            </li>
            <li>
              Stipend: Optional. This internship is designed as a
              learning-focused opportunity offering hands-on industry exposure,
              mentorship, and real-world software development experience.
            </li>
          </ul>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#777",
              marginBottom: "40px",
            }}
          >
            If you are passionate about building digital products and want to
            kickstart your career in full stack development, we would love to
            hear from you.
          </p>
<hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

        </div>
      </section>

      <Footer />
    </>
  );
}

export default CareerDetails2;